export default __webpack_public_path__ + "static/users.url-639f57a98c66c546296984f33abc4a62.svg";